<template>
  <div>
    <v-row
      v-if="isLoading"
      align="center"
      justify="center"
      fill-height
    >
      <v-progress-circular
        :size="125"
        :width="10"
        color="primary"
        indeterminate
      />
    </v-row>
    <v-row
      v-if="!isLoading"
    >
      <v-col
        cols="12"
        class="py-0 mb-3"
      >
        <v-card>
          <v-toolbar flat>
            <v-icon class="mr-3">
              local_offer
            </v-icon>
            <v-toolbar-title>{{ model.name }}</v-toolbar-title>
            <v-spacer/>
            <v-menu
              v-model="menu"
              left
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <coupon-edit-dialog
                  :coupon="model"
                  @close="onClose()"
                  @action="onEdit"
                >
                  <template v-slot:activator="{ on }">
                    <v-list-item
                      v-on="on"
                      @click.stop=""
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-icon
                            left
                            small
                          >
                            edit
                          </v-icon>
                          Edit
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </coupon-edit-dialog>

                <confirm-action
                  :model="confirmDelete"
                  :color="'error'"
                  :title="'Delete Coupon'"
                  :description="'<p>\n'+
          '          Deleting this coupon will not affect discounts for customers who have already redeemed the coupon,\n'+
          '          but new redemptions of the coupon won\'t be allowed.<br>\n'+
          '          <br>\n'+
          '          <b>Are you sure you want to delete this coupon? This can\'t be undone.</b>\n'+
          '        </p>'"
                  :action-text="'Delete'"
                  @cancel="confirmDelete = false"
                  @confirmed="onConfirmDelete"
                />

                <v-list-item
                  @click.stop="confirmDelete = true"
                >
                  <v-list-item-content>
                    <v-list-item-title class="error--text">
                      <v-icon
                        color="error"
                        left
                        small
                      >
                        delete_forever
                      </v-icon>
                      Delete
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-menu>
          </v-toolbar>

          <v-divider/>
          <v-card-text>
            <v-simple-table>
              <table>
                <tr>
                  <td>
                    <div class="caption">
                      Terms
                    </div>
                    <div class="title">
                      {{ terms }}
                    </div>
                  </td>
                  <td>
                    <div class="caption">
                      Usage
                    </div>
                    <div class="title">
                      {{ usage }}
                    </div>
                  </td>
                  <td>
                    <div class="caption">
                      Expires
                    </div>
                    <div class="title">
                      {{ expires }}
                    </div>
                  </td>
                </tr>
              </table>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        class="py-0 pr-2"
        cols="12"
        xs="12"
        md="4"
      >
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>Details</v-toolbar-title>
          </v-toolbar>
          <v-divider/>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <info-list
                  :list="infoList"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        class="py-0 pl-2"
        cols="12"
        xs="12"
        md="8"
      >
        <coupon-active-redemptions

        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from 'moment'
import { get, isEmpty } from 'lodash'
import { mapActions } from 'vuex'
import CouponEditDialog from '@/components/Coupon/CouponEditDialog'

import { getDefaultSourceFromCustomer, readableCouponTerms } from '@/services/stripe.service'
import InfoList from "../Common/InfoList"
import { formatDate, formatMoney } from "../../services/util.service"
import CouponActiveRedemptions from "./CouponActiveRedemptions"
import ConfirmAction from "../Common/ConfirmAction"


export default {
  components: {
    ConfirmAction,
    CouponActiveRedemptions,
    InfoList,
    CouponEditDialog,
  },
  data() {
    return {
      confirmDelete: false,
      model: {},
      isLoading: false,
      menu: false
    }
  },
  created() {
    this.isLoading = true

    const payload = {
      id: this.$route.params.id
    }

    this.getCoupon(payload)
      .then(res => {
        this.model = { ...res }
      })
      .finally(() => {
        this.isLoading = false
      })

  },
  methods: {
    ...mapActions([ 'getCoupon', 'deleteCoupon' ]),
    onConfirmDelete() {
      const payload = {
        id: this.$route.params.id
      }

      this.deleteCoupon(payload)
        .then(() => {
          this.$router.push({ name: 'coupons' })
        })
        .finally(() => {
          this.confirmDelete = false
        })
    },
    onEdit(data) {
      if (data && data.name) {
        this.model = {
          ...this.model,
          name: data.name
        }
      }

      this.menu = false
    },
    onClose() {
      this.menu = false
    },
    goto(id) {
    }
  },
  computed: {
    infoList() {
      return [
        {
          label: 'ID',
          value: get(this.model, 'id')
        },
        {
          label: 'Name',
          value: get(this.model, 'name')
        },
        {
          label: 'Created',
          value: formatDate(get(this.model, 'created'))
        },
        {
          label: 'Valid',
          value: this.model.valid ? 'Yes' : 'No'
        },
        {
          label: this.model.percent_off ? 'Percentage Discount' : 'Fixed amount discount',
          value: this.model.percent_off ? `${get(this.model, 'percent_off', 0)}%` : `$${get(this.model, 'amount_off', 0) / 100} ${this.model.currency}`
        },
        {
          label: 'Duration',
          value: this.model.duration === 'forever' ? 'Forever' : `${this.model.duration_in_months} months`,
        },
        {
          label: 'Redemptions',
          value: get(this.model, 'max_redemptions')
            ? `${this.model.times_redeemed} / ${this.model.max_redemptions}`
            : get(this.model, 'times_redeemed', '')
        },
        {
          label: 'Expires',
          value: formatDate(get(this.model, 'redeem_by')) || 'Never'
        }
      ]
    },
    expires() {
      return formatDate(this.model.redeem_by) || 'Never'
    },
    usage() {
      const usage = ''

      return this.model.max_redemptions
        ? `${this.model.times_redeemed} / ${this.model.max_redemptions} redemptions`
        : `${this.model.times_redeemed} redemptions`
    },
    terms() {
      return readableCouponTerms(this.model)
      const period = this.model.duration === 'forever'
        ? 'forever'
        : `for ${this.model.duration_in_months} months`

      const amount = this.model.percent_off
        ? `${this.model.percent_off}%`
        : this._formatMoney({ currency: this.model.currency, amount: this.model.amount_off })

      return `${amount} off ${period}`
    }
  },
}
</script>
